/** Facts about this device shown in the Sync Center / Settings. */
import { useSyncExternalStore } from 'react';

import type { StoragePersistence } from '@/lib/pwa/register';

let persistence: StoragePersistence | 'unknown' = 'unknown';
const listeners = new Set<() => void>();

export function setStoragePersistence(value: StoragePersistence): void {
  persistence = value;
  listeners.forEach((listener) => listener());
}

export function useStoragePersistence(): StoragePersistence | 'unknown' {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => persistence,
    () => persistence,
  );
}
